'use client';

import type { PropsWithChildren } from 'react';
import type { ErrorBoundaryProps as ReactErrorBoundaryProps } from 'react-error-boundary';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { getErrorBoundaryPropsWithFallback } from '@frameio/vapor';
import { useOnErrorWithTracking } from '../../hooks';

type ErrorBoundaryProps = PropsWithChildren<Partial<ReactErrorBoundaryProps>>;

/**
 * A HOC wrapping a React ErrorBoundary that logs the errors for observability.
 * Error boundaries should be used to prevent components from crashing the page,
 * necessitating a full refresh.
 */

export const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const errorBoundaryProps = getErrorBoundaryPropsWithFallback({
    existingProps: props,
  });
  const onErrorWithTracking = useOnErrorWithTracking(props?.onError, true);
  return (
    <ReactErrorBoundary {...errorBoundaryProps} onError={onErrorWithTracking}>
      {props?.children}
    </ReactErrorBoundary>
  );
};
